import { makeLinkToStartCourseScreen } from "features/dashboard/pages/courses-page/links";

import { linkToClassroomSection } from "../../links";

export function linkToSectionHomepage(courseId?: string, sectionId?: string) {
  return `${linkToClassroomSection(courseId, sectionId)}/section-overview`;
}

export function linkToSectionHomepageEnrollCourse(
  courseId?: string,
  sectionId?: string,
  courseIdToEnroll?: string
) {
  return `${makeLinkToStartCourseScreen(
    linkToSectionHomepage(courseId, sectionId),
    courseIdToEnroll
  )}`;
}
